import type { MeetingFormData } from '../types';
import { MAX_DURATION, MILLISECONDS_IN_MINUTE, MIN_DURATION } from './constants';

export type MeetingFormErrors = Partial<Record<keyof MeetingFormData, string>>;

export const validateMeetingForm = (formData: MeetingFormData): MeetingFormErrors => {
  const newErrors: MeetingFormErrors = {};

  if (!formData.description.trim()) {
    newErrors.description = 'Meeting title is required';
  }

  if (!formData.fromDate) {
    newErrors.fromDate = 'Meeting date is required';
  } else {
    const selectedDate = new Date(`${formData.fromDate}T${formData.fromTime}`);
    const now = new Date();
    if (selectedDate <= now) {
      newErrors.fromDate = 'Meeting must be scheduled for a future date and time';
    }
  }

  if (!formData.fromTime) {
    newErrors.fromTime = 'Meeting time is required';
  }

  const start = new Date(`${formData.fromDate}T${formData.fromTime}`);
  const end = new Date(`${formData.toDate}T${formData.toTime}`);
  const diffMinutes = (end.getTime() - start.getTime()) / MILLISECONDS_IN_MINUTE;

  if (diffMinutes < MIN_DURATION || diffMinutes > MAX_DURATION) {
    newErrors.duration = `Duration must be between ${MIN_DURATION} minutes and ${MAX_DURATION / 60} hours`;
  }

  return newErrors;
};
